import React from 'react';
import { Link } from 'react-router-dom';
import successImg from '../../../../../assets/images/success_icon.svg';
import { IoArrowBackSharp } from 'react-icons/io5';
import { BiDetail } from 'react-icons/bi';

const SuccessModal: React.FC<any> = ({ orderId }) => {
  return (
    <>
      <div className='fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50'>
        <div className='bg-white rounded-xl shadow-xl max-w-xs sm:max-w-xs md:max-w-2xl lg:max-w-2xl w-full'>
          <div className='px-6 py-8'>
            <div className={"flex justify-center items-center gap-3 'border-gray-300 bg-white'}"}>
              <div className='bg-white text-center '>
                <h2 className='font-rubik text-[30px] sm:text-[30px] md:text-[60px] lg:text-[60px] font-bold text-[#4A2D1A] mb-0 sm:mb-0 md:mb-2 lg:mb-2'>
                  Thank You!
                </h2>
                <p className='font-poppins text-xs sm:text-xs md:text-2xl lg:text-2xl text-black'>
                  Your order has been placed successfully.
                </p>
                <img src={successImg} alt='Success' className='mx-auto size-24 sm:size-24 md:size-44 lg:size-44' />
              </div>
            </div>
            <div className='flex flex-col sm:flex-row justify-between gap-2 sm:gap-2 md:gap-4 lg:gap-4 mt-2 sm:mt-2 md:mt-0 lg:mt-0'>
              <Link
                to='/products'
                className='flex items-center font-poppins bg-white text-red-800 border border-red-800 
                                py-2 px-4 text-xs sm:text-xs md:text-sm 
                                rounded-lg hover:bg-red-800 hover:text-white transition cursor-pointer'
              >
                <IoArrowBackSharp className='text-base mr-2' />
                Back to Shopping
              </Link>
              <Link
                to={`/orders/details/${orderId}`}
                className='flex items-center font-poppins bg-red-800 text-white border border-red-800 
                                py-2 px-4 text-xs sm:text-xs md:text-sm 
                                rounded-lg hover:bg-white hover:text-red-800 transition cursor-pointer'
              >
                <BiDetail className='text-base mr-2' />
                View Order Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;
